<template>
  <div class="main">
    <h3>临床技能考核</h3>
    <p>
      在线临床技能考核，丢掉繁琐的纸质考核管理模式，内置多种临床技能评分表，考官扫码即可评分，一键发布考核成绩。
    </p>
    <div class="diagram_view">
      <el-image style="height: 360px" :src="url" :preview-src-list="srcList">
      </el-image>
      <el-image style="height: 360px" :src="urlTwo" :preview-src-list="srcList">
      </el-image>
    </div>
    <div class="button_view">
      <el-button type="primary" @click="customerInfo = true"
        >联系客服试用</el-button
      >
      <el-button type="primary" @click="qrdialogVisible = true"
        >扫码体验考核打分</el-button
      >
    </div>
    <!-- 体验码弹窗 -->
    <div class="experience_pop">
      <el-dialog
        :title="'考核体验'"
        :visible.sync="qrdialogVisible"
        width="18%"
        :close-on-click-modal="false"
      >
        <div>
          <vueqr
            :bgSrc="config.logo"
            :text="config.value"
            :logoSrc="config.imagePath"
            :size="300"
            ref="isAn"
          >
          </vueqr>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="qrdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qrdialogVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 联系客服弹窗 -->
    <div class="modify">
      <el-dialog
        title="温馨提示"
        :visible.sync="customerInfo"
        :close-on-click-modal="false"
        width="25vw"
      >
        <div class="mian">
          <!-- QQ：1194619665  电话：15878893290  彭经理
QQ：1926197022  电话：13877286037  罗经理
QQ：1782339397  电话：18978029070  黄经理 -->
          <!-- <div class="flex">
            <p>QQ：1194619665</p>
            <p>电话：15878893290 彭经理</p>
          </div> -->
          <div class="flex">
            <p>QQ：1926197022</p>
            <p>电话：13877286037 罗经理</p>
          </div>
          <div class="flex">
            <p>QQ：3971609</p>
            <p>电话：13978105008（微信同号） 黄经理</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="customerInfo = false">取 消</el-button>
          <el-button type="primary" @click="customerInfo = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import vueqr from "vue-qr";
export default {
  data() {
    return {
      url: require("@/assets/images/app_d.png"),
      urlTwo: require("@/assets/images/PC_d.png"),
      srcList: [
        require("@/assets/images/app_d.png"),
        require("@/assets/images/PC_d.png"),
      ],
      config: {
        //二维码内的信息
        imagePath: require("@/assets/yunlogo.png"), //中间logo的地址
        value: "http://yklappt.tibosi.com/#/experience", //显示的值、跳转的地址
      },
      loadingQr: true,
      customerInfo: false, // 客服信息弹窗
      qrdialogVisible: false, // 体验二维码弹窗
    };
  },
  components: {
    vueqr,
  },
};
</script>

<style lang="scss" scoped>
.main {
  //   height: 100%;
  width: 100%;
  min-width: 1650px;
  min-height: 800px;
  background-color: rgb(255, 255, 255);
  padding: 30px 24px;
  h3 {
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3a3a3a;
    text-align: center;
    margin-bottom: 24px;
  }
  p {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3a3a3a;
    text-align: center;
  }
  .diagram_view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .el-image {
      //   height: 360px;
      &:nth-child(1) {
        margin-right: 100px;
      }
    }
  }
  .button_view {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      background: #0084ea;
      &:nth-child(1) {
        margin-right: 140px;
      }
    }
  }
}
.experience_pop {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    text-align: center;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 342px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
  .red_p {
    color: #333333;
    margin-bottom: 10px;
    span {
      color: #e54d4d;
      font-size: 16px;
    }
  }
}

.modify {
  ::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
    width: 100% !important;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    flex-direction: column;
    align-items: center;
    .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      p{
        &:nth-child(1){
          margin-right: 12px;
        }
      }
    }
    p {
      //   width: 120px;
      line-height: 24px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 400px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
</style>
